module.exports = __webpack_public_path__ + "img/aside-new-bg.087495c9.png";